var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSendIcon = function SvgSendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.834 5.491-5.989 5.99 1.823 4.686 4.166-10.676Zm-7.315 4.664 5.99-5.99L3.831 8.333l4.687 1.823Zm8.658-9.027c.155-.045.49-.133.851-.012.404.135.72.451.856.855.12.362.032.696-.013.852-.05.17-.129.373-.205.57l-5.517 14.135c-.086.22-.171.44-.255.61-.072.145-.242.479-.603.666a1.354 1.354 0 0 1-1.25 0c-.36-.188-.53-.522-.601-.667-.085-.17-.17-.39-.255-.61l-2.16-5.553-5.52-2.147-.032-.012c-.22-.086-.44-.17-.61-.255-.145-.071-.479-.241-.667-.602a1.354 1.354 0 0 1 0-1.25c.187-.36.52-.53.665-.602.17-.084.39-.17.61-.256l.032-.012 14.104-5.504c.197-.077.399-.156.57-.206Z",
    fill: "currentColor"
  })));
};

export default SvgSendIcon;